/**
 * Set a value in localStorage with a given TTL in days.
 *
 * @param key - localStorage key
 * @param value - value to store
 * @param expiryInDays - TTL in days
 */
export const setClientWithExpiry = (
  key: string,
  value: any,
  expiryInDays: number = 7 // default to 7 days
) =>
  localStorage.setItem(
    key,
    JSON.stringify({
      value,
      expiry: Date.now() + expiryInDays * 24 * 360000, // in milliseconds
    })
  )

/**
 * Retrieves a value from localStorage that was set with a TTL.
 *
 * @param key - localStorage key
 * @returns the stored value if it has not expired, else null
 */
export const getClientIfNotExpired = (key: string) => {
  const itemStr = localStorage.getItem(key)
  return itemStr
    ? JSON.parse(itemStr).expiry > Date.now()
      ? JSON.parse(itemStr).value
      : (localStorage.removeItem(key), null)
    : null
}
